<header class="site-header">
  <nav class="nav-container" aria-label="Main navigation">
    <a routerLink="/" class="nav-logo" (click)="closeMenu()">L &amp; J</a>

    <button
      class="menu-toggle"
      [attr.aria-expanded]="mobileMenuOpen()"
      aria-controls="main-nav"
      aria-label="Toggle navigation menu"
      (click)="toggleMenu()"
    >
      <span class="menu-bar"></span>
      <span class="menu-bar"></span>
      <span class="menu-bar"></span>
    </button>

    <div id="main-nav" class="nav-links-wrapper" [class.open]="mobileMenuOpen()">
      <ul class="nav-links" role="list">
        @for (link of navLinks().top; track link.path) {
          <li>
            <a
              [attr.data-path]="link.path"
              [routerLink]="link.path"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: link.path === '/' }"
              (click)="closeMenu()"
            >
              {{ link.label }}
            </a>
          </li>
        }
      </ul>

      @if (navLinks().admin.length > 0) {
        <div class="nav-admin-item">
          <details class="nav-admin-dropdown" #adminDetails routerLinkActive="active">
            <summary class="nav-admin-summary">Admin&hellip;</summary>
            <ul class="nav-admin-menu" role="list">
              @for (link of navLinks().admin; track link.path) {
                <li>
                  <a
                    [routerLink]="link.path"
                    routerLinkActive="active"
                    (click)="closeMenu(); adminDetails.removeAttribute('open')"
                  >
                    {{ link.label }}
                  </a>
                </li>
              }
            </ul>
          </details>
        </div>
      }
    </div>
  </nav>
</header>

<app-toast-host />

<main>
  <router-outlet />
</main>

<footer class="site-footer">
  <p class="footer-names">Lizzie &amp; Jon</p>
  <p class="footer-date">November 2027 · Paisley, Scotland</p>
</footer>
